import { Card, CardContent, Stack, TextField, Typography, Button } from "@mui/material";
import type { Charger } from "../../../types";

interface DiagnosticsCardProps {
  chargers: Charger[];
  diagnosticChargePoint: string;
  canDownloadDiagnostics: boolean;
  setDiagnosticChargePoint: (value: string) => void;
  onRequestDiagnostics: () => void;
  onDownloadDiagnostics: () => void;
}

export function DiagnosticsCard({
  chargers,
  diagnosticChargePoint,
  canDownloadDiagnostics,
  setDiagnosticChargePoint,
  onRequestDiagnostics,
  onDownloadDiagnostics,
}: DiagnosticsCardProps) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" gutterBottom>Diagnostics Log Download</Typography>
        <Stack direction={{ xs: "column", md: "row" }} spacing={1} alignItems={{ md: "center" }}>
          <TextField
            label="Charge Point ID"
            value={diagnosticChargePoint}
            onChange={(e) => setDiagnosticChargePoint(e.target.value)}
            select
            SelectProps={{ native: true }}
            fullWidth
          >
            <option value="">Select charger</option>
            {chargers.map((c) => (
              <option key={c.charge_point_id} value={c.charge_point_id}>
                {c.charge_point_id} ({c.ocpp_version ?? "unknown"})
              </option>
            ))}
          </TextField>
          <Button variant="contained" onClick={onRequestDiagnostics} disabled={!diagnosticChargePoint}>
            Trigger Download
          </Button>
          <Button variant="outlined" onClick={onDownloadDiagnostics} disabled={!canDownloadDiagnostics}>
            Download to Local
          </Button>
        </Stack>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Uses GetDiagnostics for OCPP 1.6 and GetLog for OCPP 2.0.1.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Request diagnostics first, then use the download button once the charger has uploaded the file.
        </Typography>
      </CardContent>
    </Card>
  );
}
